import { Routes } from "@angular/router";
import { APPROUTES } from "../../app.routes.strings";
import { AuthGuardService } from "app/infrastructure/oidc/auth-guard.service";
import { OrganizationComponent } from "./organization.component";

export const ORGANIZATION_ROUTES: Routes = [
  { path: APPROUTES.organization.base, component: OrganizationComponent, canActivate: [AuthGuardService] },
];
